import { AssociateCandidatesComponent } from "./associate-candidates.component";
export var AssociateCandidatesModule = angular
    .module('associateCandidates', [])
    .component(AssociateCandidatesComponent.selector, AssociateCandidatesComponent.component)
    .name;
//# sourceMappingURL=associate-candidates.module.js.map